import { createI18n } from 'vue-i18n';

const i18n = createI18n({
	legacy: true,
	globalInjection: true,
	locale: localStorage.getItem('lang') || 'en_us',
	messages: {
		zh_cn: require('./assets/languages/zh_CN.json'),
		zh_hk: require('./assets/languages/zh_HK.json'),
		en_us: require('./assets/languages/en_US.json'),
		th_th: require('./assets/languages/th_TH.json'),
		ja_jp: require('./assets/languages/ja_JP.json'),
		ko_kr: require('./assets/languages/ko_KR.json'),
		ms_my: require('./assets/languages/ms_MY.json'),
		pt_br: require('./assets/languages/pt_BR.json'),
		ir_fa: require('./assets/languages/ir_fa.json'),
		ar_ar: require('./assets/languages/ar_ar.json'),
		db_de: require('./assets/languages/db_de.json'),
		id_ind: require('./assets/languages/id_ind.json'),
		vi_vn: require('./assets/languages/vi_VN.json'),
	},
});

export const translate = (key, params) => i18n.global.t(key, params);

export default i18n;
